var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.FormControlPlainText, {
    attrs: { value: _setup.fileSize, "form-id": _vm.formId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }